import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { X, ArrowUpRight } from "lucide-react";
import { EASE } from "@/lib/motion";
import { WalletButton } from "@/components/WalletButton";
import { BuyButton, ChartButton } from "@/components/Buttons";
import { PROJECT_NAME, NETWORK_NAME, CHAIN_ID, NATIVE_ASSET, X_URL } from "@/config/actra";

const LINKS = [
    { label: "Protocol", to: "/", hash: "#action-economy" },
    { label: "Tasks", to: "/tasks" },
    { label: "Agents", to: "/agents" },
    { label: "Proof", to: "/proof" },
    { label: "Reputation", to: "/reputation" },
    { label: "Explorer", to: "/explorer" },
    { label: "Docs", to: "/docs" },
    { label: "About", to: "/about" },
];

export const MobileMenu = ({ open, onClose, onProtocol }) => (
    <AnimatePresence>
        {open && (
            <motion.div
                data-testid="mobile-menu"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 z-[60] flex flex-col bg-[#040811]/97 backdrop-blur-2xl lg:hidden"
                role="dialog"
                aria-modal="true"
                aria-label="Navigation menu"
            >
                <div className="flex h-16 items-center justify-between px-5">
                    <span className="flex items-center gap-3">
                        <img src="/actra-logo.png" alt="" className="h-7 w-7 object-contain" style={{ mixBlendMode: "screen" }} />
                        <span className="font-display text-lg font-bold tracking-[0.14em]">{PROJECT_NAME}</span>
                    </span>
                    <button data-testid="mobile-menu-close" aria-label="Close menu" onClick={onClose} className="border border-white/10 p-2.5">
                        <X size={18} />
                    </button>
                </div>

                <nav aria-label="Mobile" className="flex flex-1 flex-col justify-center gap-1 px-6">
                    {LINKS.map((l, i) => (
                        <motion.div
                            key={l.label}
                            initial={{ opacity: 0, x: -24 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.06 * i, duration: 0.5, ease: EASE }}
                        >
                            <Link
                                to={l.to}
                                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                                onClick={(e) => {
                                    if (l.hash) {
                                        e.preventDefault();
                                        onProtocol(e);
                                    } else {
                                        onClose();
                                    }
                                }}
                                className="group flex items-center justify-between border-b border-white/[0.06] py-4"
                            >
                                <span className="font-display text-3xl font-bold uppercase tracking-tightest text-ink transition-colors group-hover:text-[#31D8FF]">
                                    {l.label}
                                </span>
                                <span className="font-mono text-[10px] tracking-[0.3em] text-mute">0{i + 1}</span>
                            </Link>
                        </motion.div>
                    ))}
                </nav>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.5, ease: EASE }}
                    className="space-y-4 px-6 pb-10"
                >
                    <div className="flex flex-wrap items-center gap-3">
                        <BuyButton />
                        <ChartButton />
                    </div>
                    <WalletButton block />
                    <p className="label-tech">
                        {NETWORK_NAME} · CHAIN {CHAIN_ID} · {NATIVE_ASSET} SETTLEMENT
                    </p>
                    <a
                        href={X_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="mobile-x-link"
                        className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-mute"
                    >
                        FOLLOW ACTRA ON X <ArrowUpRight size={14} />
                    </a>
                </motion.div>
            </motion.div>
        )}
    </AnimatePresence>
);

export default MobileMenu;
